var jade = require("/Users/shishirarora/Projects/file-upload/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var jade_debug = [ new jade.DebugItem( 1, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ) ];
try {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (body, css, description, entry, keywords, state, title) {
jade_debug.unshift(new jade.DebugItem( 0, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
jade_debug.unshift(new jade.DebugItem( 1, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<!DOCTYPE html>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 2, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<html lang=\"en\" class=\"no-js\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 3, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<head>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 4, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 5, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta http-equiv=\"Cache-Control\" content=\"no-cache, no-store, must-revalidate\">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 6, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta http-equiv=\"Pragma\" content=\"no-cache\">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 7, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta http-equiv=\"Expires\" content=\"0\">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 8, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta name=\"p:domain_verify\" content=\"578fa68d1988f66b6eeb98681b6646ae\">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 9, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta name=\"fragment\" content=\"!\">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 10, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 11, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<title>" + (jade.escape(null == (jade_interp = title) ? "" : jade_interp)));
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</title>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 12, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta name=\"title\"" + (jade.attr("content", title, true, true)) + ">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 13, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta name=\"description\"" + (jade.attr("content", description, true, true)) + ">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 14, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta name=\"keywords\"" + (jade.attr("content", keywords, true, true)) + ">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 15, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta name=\"og_title\" property=\"og:title\" content=\"Project Title\">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 16, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<meta name=\"og_site_name\" property=\"og:site_name\" content=\"Project Title\">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 17, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<style id=\"css\">" + (null == (jade_interp = css) ? "" : jade_interp));
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</style>");
jade_debug.shift();
jade_debug.shift();
buf.push("</head>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 18, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<body>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 19, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<div id=\"app\">" + (null == (jade_interp = body) ? "" : jade_interp));
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 20, "/Users/shishirarora/Projects/file-upload/src/views/index.jade" ));
buf.push("<script id=\"source\"" + (jade.attr("src", entry, true, true)) + (jade.attr("data-initial-state", state, true, true)) + ">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</script>");
jade_debug.shift();
jade_debug.shift();
buf.push("</body>");
jade_debug.shift();
jade_debug.shift();
buf.push("</html>");
jade_debug.shift();
jade_debug.shift();}.call(this,"body" in locals_for_with?locals_for_with.body:typeof body!=="undefined"?body:undefined,"css" in locals_for_with?locals_for_with.css:typeof css!=="undefined"?css:undefined,"description" in locals_for_with?locals_for_with.description:typeof description!=="undefined"?description:undefined,"entry" in locals_for_with?locals_for_with.entry:typeof entry!=="undefined"?entry:undefined,"keywords" in locals_for_with?locals_for_with.keywords:typeof keywords!=="undefined"?keywords:undefined,"state" in locals_for_with?locals_for_with.state:typeof state!=="undefined"?state:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined));;return buf.join("");
} catch (err) {
  jade.rethrow(err, jade_debug[0].filename, jade_debug[0].lineno, "doctype html\nhtml(class=\"no-js\", lang=\"en\")\n  head\n    meta(http-equiv='Content-Type', content='text/html; charset=utf-8')\n    meta(http-equiv='Cache-Control', content='no-cache, no-store, must-revalidate')\n    meta(http-equiv='Pragma', content='no-cache')\n    meta(http-equiv='Expires', content='0')\n    meta(name=\"p:domain_verify\", content=\"578fa68d1988f66b6eeb98681b6646ae\")\n    meta(name='fragment', content='!')\n    meta(name=\"viewport\", content=\"width=device-width, initial-scale=1.0\")\n    title= title\n    meta(name=\"title\", content=title)\n    meta(name=\"description\", content=description)\n    meta(name=\"keywords\", content=keywords)\n    meta(name=\"og_title\" property=\"og:title\", content=\"Project Title\")\n    meta(name=\"og_site_name\" property=\"og:site_name\" content=\"Project Title\")\n    style#css!= css\n  body\n    #app!= body\n    script#source(src=entry, data-initial-state=state)\n");
}
}


//////////////////
// WEBPACK FOOTER
// ./views/index.jade
// module id = 71
// module chunks = 0